/**
 * HTML-Escaping für Diagrammtexte (Datenschutz-Gate 05.10.).
 *
 * ApexCharts setzt Achsenbeschriftungen, Tooltips und Legenden teils per innerHTML.
 * Jeder Text, der aus Daten stammt (Namen, Titel, Kategorien, Reihennamen), läuft
 * deshalb vor der Übergabe an ApexCharts durch diese EINE Funktion. Aufrufer bauen
 * Diagramm-Optionen nie selbst, sondern nur über `baueBalkenOptionen` (balken-optionen.ts).
 */
const ERSATZ: Record<string, string> = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
};

export function htmlEscape(text: string): string {
  return text.replace(/[&<>"']/g, (z) => ERSATZ[z]!);
}
